import { select } from "d3";
import { textactive } from "../../_helpers/_parametric_tools";
import { HoverElement } from "./HoverElement";

export class DotHover extends HoverElement {
  constructor(params) {
    super({ ...params });
    this.type = params.type;
    this.create({ ...params });
  }

  show({ xPix, yt, dataYt, keyYt, highlightCandles = null, i = "" }) {
    const isKeys = Object.keys(dataYt).length === 0;
    if (!isKeys) {
      if (highlightCandles === null || highlightCandles) {
        select(`.dot${this.name}${i}`)
          .style("opacity", 1)
          .attr("transform", `translate(${xPix},${yt(dataYt[keyYt])})`);
      } else {
        select(`.dot${this.name}${i}`).style("opacity", 0);
      }
    }
  }

  create({
    strokeColor,
    i = "",
    fillColor = textactive(this.colorTheme),
    circleSize = 2,
    strokeWidth = 1.5
  }) {
    // one dot
    if (this.type === "dot") {
      this.className = "dot" + this.name + i;
      this.svg.dot = this.svg.append("g");
      this.svg.dot
        .append("circle")
        .attr("class", this.className)
        .style("opacity", 0)
        .attr("fill", fillColor)
        .attr("stroke", strokeColor)
        .attr("stroke-width", strokeWidth)
        .attr("r", circleSize);
    }
  }
}
